module.exports = __webpack_public_path__ + "bb9a359afc17edc2c275b4212b8f2fd2.woff";